import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";

const getOrganizationTypeData = (state, setState) => {
    const api = initApi(API_NAMES.CLUB, state, setState);
    const url = `/OrganizationType`;

    return api?.executeArray ? api.executeArray(url, 'GET') : null;
};

const OrganizationTypeData = {
  getOrganizationTypeData
};

export default OrganizationTypeData;